import { render } from "./ScenarioPager.vue?vue&type=template&id=4ea2fce0"
import script from "./ScenarioPager.js?vue&type=script&lang=js"
export * from "./ScenarioPager.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__